import React from 'react'
import { Button } from 'components/Button'

import { Modal } from 'shared/modal'

import classes from './DeleteSessionModal.module.scss'

interface DeleteSessionModalProps {
  close: () => void
  onChange?: () => void
  session: Resource.SessionResource
}

export const DeleteSessionModal: React.FC<DeleteSessionModalProps> = ({ close, onChange, session }) => {
  const confirm = () => {
    fetch(`/api/sessions/${session.id}`, { method: 'DELETE' }).then(onChange).then(close)
  }

  return (
    <Modal size="sm">
      <div className={classes.title}>
        <h3>Excluir ensaio</h3>
      </div>
      <div className={classes.divider} />
      <div className={classes.description}>
        <h4>Confirma a exclusão do ensaio ID {session.id}?</h4>
      </div>
      <div className={classes.divider} />
      <div className={classes.buttons}>
        <Button outline onClick={close}>
          Cancelar
        </Button>
        <Button onClick={confirm}>Confirmar</Button>
      </div>
    </Modal>
  )
}
